import Button from 'components/base/Button';
import Section from 'components/base/Section';
import { Col, Row, Spinner } from 'react-bootstrap';
import EcomAddressTable from 'components/tables/EcomAddressTable';
import DeliveryType from 'components/modules/e-commerce/checkout/DeliveryType';
import { PaymentMethod } from 'components/modules/e-commerce/checkout/PaymentMethod';
import { currencyFormat } from 'helpers/utils';
import CheckoutSummaryCard from 'components/modules/e-commerce/checkout/CheckoutSummaryCard';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { defaultBreadcrumbItems } from 'data/commonData';
import { createOrder } from 'api/orders/_requests';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { removeFromCart } from 'redux-state/user/cartSlice';

const Checkout = () => {
  const { vendorId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cart } = useSelector((state: RootState) => state.user.cart);
  const { shippingAddress, billingAddress } = useSelector(
    (state: RootState) => state.user.customer
  );
  const [submitLoading, setSubmitLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('credit_card');
  const [paymentTerm, setPaymentTerm] = useState('100% Advance');

  const totalAmount =
    cart?.find(item => item.vendorId === vendorId)?.totalAmount || 0;
  const totalAmountAfterDiscount = cart?.find(
    item => item.vendorId === vendorId
  )?.totalAmountAfterDiscount;

  const handleOrderSubmit = async () => {
    setSubmitLoading(true);
    const res = await createOrder({
      vendorId: vendorId as string,
      paymentMethod,
      paymentTerm
    });
    if (res) {
      toast.success('Order created successfully');
      dispatch(removeFromCart(vendorId as string));
      setSubmitLoading(false);
      navigate(`/order-details/${res._id}`);
    }
  };

  return (
    <div className="pt-5 mb-9">
      <Section small className="py-0">
        {/* <PageBreadcrumb items={defaultBreadcrumbItems} /> */}
        <h2 className="mb-5">Check out</h2>
        <Row className="justify-content-between">
          <Col lg={7}>
            <form>
              <div className="d-flex align-items-end mb-4">
                <h3 className="mb-0 me-3">Shipping Details</h3>
                <Link
                  to="/profile"
                  className="p-0 text-decoration-underline fw-semibold"
                >
                  Edit
                </Link>
              </div>
              <EcomAddressTable
                data={[
                  {
                    labelIcon: 'home',
                    label: 'Address',
                    value: `${shippingAddress?.street}, ${shippingAddress?.city}, ${shippingAddress?.state}, ${shippingAddress?.postalCode}, ${shippingAddress?.country}`
                  },
                  {
                    labelIcon: 'phone',
                    label: 'Phone',
                    value: shippingAddress?.phone || ''
                  }
                ]}
              />
              <hr className="my-6" />
              <div className="d-flex align-items-end mb-4">
                <h3 className="mb-0 me-3">Billing Details</h3>
                <Link
                  to="/profile"
                  className="p-0 text-decoration-underline fw-semibold"
                >
                  Edit
                </Link>
              </div>
              {/* <Form.Check type="checkbox" id="sameAsShipping" className="mb-4">
                <Form.Check.Input type="checkbox" />
                <Form.Check.Label className="fs-8 fw-normal">
                  Same as shipping address
                </Form.Check.Label>
              </Form.Check> */}
              <EcomAddressTable
                data={[
                  {
                    labelIcon: 'home',
                    label: 'Address',
                    value: `${billingAddress?.street}, ${billingAddress?.city}, ${billingAddress?.state}, ${billingAddress?.postalCode}, ${billingAddress?.country}`
                  },
                  {
                    labelIcon: 'phone',
                    label: 'Phone',
                    value: billingAddress?.phone || ''
                  }
                ]}
              />
              <hr className="my-6" />
              <DeliveryType />
              <hr className="my-6" />
              <PaymentMethod
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                paymentTerm={paymentTerm}
                setPaymentTerm={setPaymentTerm}
              />

              <div className="d-flex flex-column flex-sm-row mb-7 mb-lg-0">
                <Button
                  variant="primary"
                  type="button"
                  className="w-100"
                  onClick={handleOrderSubmit}
                >
                  {submitLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : paymentMethod === 'credit_card' ? (
                    `Pay ${currencyFormat(
                      totalAmountAfterDiscount ?? totalAmount,
                      { currency: 'SAR' }
                    )}`
                  ) : (
                    'Create Order'
                  )}
                </Button>
              </div>
            </form>
          </Col>
          <Col lg={5} xl={4}>
            <CheckoutSummaryCard />
          </Col>
        </Row>
      </Section>
    </div>
  );
};

export default Checkout;
